import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

// Base URL clean up (trim trailing slash if any)
const getBaseUrl = () => {
  return API_BASE.endsWith('/') ? API_BASE.slice(0, -1) : API_BASE;
};

// Common headers config helper
const getHeaders = () => {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

export const incentiveGeneratorService = {
  /**
   * Fetches the list of generated incentives
   * Default includes: isApproved=false
   */
  async getIncentives(params = {}) {
    try {
      const base = getBaseUrl();
      const headers = getHeaders();
      const response = await axios.get(`${base}/api/IncentiveGenerator`, {
        params: {
          isApproved: false, // Default request parameter
          ...params
        },
        headers
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch incentive list');
    }
  },

  /**
   * Approves a specific generated incentive
   * @param {Object} payload { id: String, remark: String }
   */
  async approveIncentive(payload) {
    try {
      const base = getBaseUrl();
      const headers = getHeaders();
      const response = await axios.put(`${base}/api/IncentiveGenerator/approve`, payload, {
        headers
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to approve incentive');
    }
  }
};
